import React, { useEffect, useState } from 'react';
import { generateClient } from '@aws-amplify/api';
import { getAdCampaigns } from '@/graphql/queries';
import { useNavigate } from 'react-router-dom';

const client = generateClient();

const CampaignList = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await client.graphql({
          query: getAdCampaigns,
          variables: {
            limit: 20,
            sorting: [{ field: 'flight_start_date', order: 'desc' }],
          },
        });
        const data = response.data?.getAdCampaigns?.ad_campaigns || [];
        setCampaigns(data);
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCampaigns();
  }, []);

  const handleCreateNew = () => {
    navigate('/campaigns/new');
  };

  return (
    <div className="container-fluid py-4 px-3 px-md-5">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
        <h2 className="fw-bold m-0">Campaigns</h2>
        <button className="btn btn-primary px-4" onClick={handleCreateNew}>
          + Create New
        </button>
      </div>

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status" />
          <p className="mt-3 text-muted">Loading campaigns...</p>
        </div>
      ) : campaigns.length === 0 ? (
        <div className="alert alert-secondary text-center py-4">
          <p className="mb-1 fs-5">No campaigns found.</p>
          <p className="mb-0 text-muted">Click "Create New" to add one.</p>
        </div>
      ) : (
        <>
          {/* Desktop Table View */}
          <div className="d-none d-md-block">
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Flight Dates</th>
                    <th>Spend</th>
                    <th>Platforms</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((c) => (
                    <tr key={c.id}>
                      <td>{c.name}</td>
                      <td>
                        {c.flight_start_date && c.flight_end_date
                          ? `${new Date(c.flight_start_date).toLocaleDateString()} - ${new Date(c.flight_end_date).toLocaleDateString()}`
                          : '—'}
                      </td>
                      <td>{c.spend != null ? `$${c.spend.toLocaleString()}` : '—'}</td>
                      <td>{c.ad_platforms?.map((p) => p.name).join(', ') || '—'}</td>
                      <td>{new Date(c.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="d-block d-md-none">
            {campaigns.map((c) => (
              <div className="card mb-3 shadow-sm" key={c.id}>
                <div className="card-body">
                  <h5 className="card-title">{c.name}</h5>
                  <p className="card-text mb-1">
                    <strong>Flight:</strong>{' '}
                    {c.flight_start_date && c.flight_end_date
                      ? `${new Date(c.flight_start_date).toLocaleDateString()} - ${new Date(c.flight_end_date).toLocaleDateString()}`
                      : '—'}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Spend:</strong> {c.spend != null ? `$${c.spend.toLocaleString()}` : '—'}
                  </p>
                  <p className="card-text mb-1">
                    <strong>Platforms:</strong>{' '}
                    {c.ad_platforms?.map((p) => p.name).join(', ') || '—'}
                  </p>
                  <p className="card-text">
                    <strong>Created:</strong>{' '}
                    {new Date(c.created_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CampaignList;


